/*
 * Combined variant dropdown (custom, professional UI).
 *
 * The visible control is a custom toggle + menu. Selecting a row drives the
 * theme's existing per-option controls (hidden) by setting each option's
 * accessible <select> and dispatching a native `change` event. Those bubble up
 * to <product-variant-selector>, which recomputes the variant and updates the
 * price / image / buy button / inventory — so the buy flow stays untouched.
 */
(() => {
    const A11Y_SELECT = '.\\#product-options-dropdown-a11y-select';

    function initRoot(pvc) {
        const component = pvc.closest('product-variant-selector');
        const toggle = pvc.querySelector('[data-pvc-toggle]');
        const menu = pvc.querySelector('[data-pvc-menu]');
        const curTitle = pvc.querySelector('[data-pvc-current-title]');
        const curBadge = pvc.querySelector('[data-pvc-current-badge]');
        const curShip = pvc.querySelector('[data-pvc-current-ship]');
        const curPrice = pvc.querySelector('[data-pvc-current-price]');
        const curDisc = pvc.querySelector('[data-pvc-current-disc]');
        const curThumb = pvc.querySelector('[data-pvc-current-thumb]');
        if (!component || !toggle || !menu) return;

        const backdrop = pvc.querySelector('[data-pvc-backdrop]');
        const closeBtn = pvc.querySelector('[data-pvc-close]');
        const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;
        const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';
        const open = () => {
            menu.hidden = false;
            if (backdrop) backdrop.hidden = false;
            toggle.setAttribute('aria-expanded', 'true');
            if (isDesktop()) document.body.style.overflow = 'hidden';
        };
        const close = () => {
            menu.hidden = true;
            if (backdrop) backdrop.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        };

        toggle.addEventListener('click', (e) => {
            e.stopPropagation();
            isOpen() ? close() : open();
        });
        if (closeBtn) closeBtn.addEventListener('click', (e) => { e.stopPropagation(); close(); });
        if (backdrop) backdrop.addEventListener('click', () => close());

        menu.querySelectorAll('[data-pvc-option]').forEach((opt) => {
            opt.addEventListener('click', (e) => {
                e.stopPropagation();
                if (opt.disabled || opt.classList.contains('is-disabled')) return;

                // Drive the hidden per-option controls -> theme updates price/image.
                let values;
                try {
                    values = JSON.parse(opt.dataset.options || '[]');
                } catch (err) {
                    values = [];
                }
                values.forEach((value, index) => {
                    const select = component.querySelector(
                        `${A11Y_SELECT}[data-option-index="${index}"]`
                    );
                    if (!select) return;
                    // Match the option robustly (by value, fall back to label text).
                    const opts = Array.from(select.options);
                    const match =
                        opts.find((o) => o.value === value) ||
                        opts.find((o) => o.textContent.trim() === String(value).trim());
                    if (match) select.value = match.value;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                });

                // GUARANTEE the correct variant is submitted to cart, regardless of
                // how the theme's option->variant matching resolved. Runs last so it
                // wins over the value the change handlers may have set.
                const idInput = component.querySelector('input[name="id"]');
                if (idInput && opt.dataset.variantId) idInput.value = opt.dataset.variantId;

                // Reflect selection in the visible toggle.
                if (curTitle) curTitle.textContent = opt.dataset.title || '';
                if (curBadge) {
                    curBadge.textContent = opt.dataset.badge || '';
                    curBadge.className = 'pvc-badge pvc-badge--' + (opt.dataset.state || 'in') + (opt.dataset.one ? ' pvc-badge--one' : '');
                }
                // Recolor the whole selected field to match the new variant's stock state.
                toggle.dataset.state = opt.dataset.state || 'in';
                if (curShip) {
                    const out = opt.dataset.state === 'out';
                    curShip.textContent = out ? '' : (opt.dataset.ship || '');
                    curShip.hidden = out;
                }
                if (curPrice) {
                    const old = opt.dataset.priceOld;
                    const now = opt.dataset.price || '';
                    curPrice.textContent = '';
                    if (old) {
                        const s = document.createElement('s');
                        s.textContent = old;
                        curPrice.append(s, ' ');
                    }
                    curPrice.append(now);
                    curPrice.classList.toggle('pvc-option-price--sale', !!old);
                }
                toggle.classList.toggle('is-sale', !!opt.dataset.priceOld);
                if (curDisc) {
                    const disc = opt.dataset.disc;
                    curDisc.textContent = disc || '';
                    curDisc.hidden = !disc;
                }
                if (curThumb && opt.dataset.thumb) curThumb.src = opt.dataset.thumb;
                menu.querySelectorAll('.pvc-option').forEach((o) => {
                    const selected = o === opt;
                    o.classList.toggle('is-selected', selected);
                    if (selected) o.setAttribute('aria-selected', 'true');
                    else o.removeAttribute('aria-selected');
                });

                close();
            });
        });

        document.addEventListener('click', (e) => {
            if (isOpen() && !pvc.contains(e.target)) close();
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && isOpen()) close();
        });
    }

    document.querySelectorAll('[data-pvc-root]').forEach(initRoot);
})();
